<div class="sidebar">
    <!-- Company Switcher -->
    <div class="company-switcher" *ngIf="company">
        <label class="switcher-label">{{t('Company')}}</label>
        <button type="button" class="btn btn-sm btn-link" (click)="refreshCompanies()" [disabled]="refreshingCompanies" aria-label="Refresh companies">{{refreshingCompanies ? 'Loading…' : 'Refresh'}}</button>
        <div class="select-wrapper">
            <select [ngModel]="companySelection" (ngModelChange)="setCompany($event)">
                <option *ngIf="canUseManualAllCompanies()" [value]="manual_all_companies">All Companies — Manual Wallet</option>
                <option *ngFor="let c of company" [value]="c.uuid">{{c.name}}</option>
            </select>
            <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>
        </div>
    </div>

    <a *ngIf="canUseConsolidatedWallet()" class="nav-item" [routerLink]="['/lo', selected_company, 'consolidated-wallet']" routerLinkActive="active">Consolidated Wallet / Top-up</a>

    <a *ngIf="canUseIntercompanyAdjustment()" class="nav-item" [routerLink]="['/lo', selected_company, 'intercompany-adjustment']" routerLinkActive="active">Inter-company Adjustment</a>

    <!-- Navigation -->
    <nav class="sidebar-nav">

        <!-- Customise toolbar -->
        <div class="fav-toolbar" *ngIf="menus && menus.length">
            <button type="button" class="fav-toolbar-btn" [class.active]="favMode" (click)="toggleFavMode()">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                </svg>
                <span>{{ favMode ? t('Done') : t('Customize') }}</span>
            </button>
            <div class="fav-hint" *ngIf="favMode">{{t('Pick the features you use most')}}</div>
        </div>

        <!-- EDIT MODE: full menu, each row pins/unpins -->
        <ng-container *ngIf="favMode">
            <div class="nav-section" *ngFor="let menu of menus">
                <div class="section-title">{{t(menu.title)}}</div>
                <div *ngFor="let item of menu.children"
                    class="nav-item fav-edit-item"
                    [class.is-fav]="isFavorite(item)"
                    (click)="toggleFavorite(item, $event)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" [attr.fill]="isFavorite(item) ? '#f59e0b' : 'none'" stroke="#9ca3af" stroke-width="1">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    <span class="nav-label">{{t(item.title)}}</span>
                </div>
            </div>
        </ng-container>

        <!-- COLLAPSED: favourites only + single "More" button -->
        <ng-container *ngIf="!favMode && hasFavorites && !showAll">
            <div class="nav-section" *ngFor="let menu of favoriteMenus"
                [class.collapsed]="isGroupCollapsed(menu)">
                <button type="button" class="section-title" (click)="toggleGroup(menu, $event)">
                    <span class="section-title-text">{{t(menu.title)}}</span>
                    <svg class="section-chevron" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </button>
                <ng-container *ngIf="!isGroupCollapsed(menu)">
                    <a *ngFor="let item of menu.children"
                        class="nav-item"
                        [routerLink]="routeReplace(item.path, item.route)"
                        routerLinkActive="active">
                        <span class="nav-label">{{t(item.title)}}</span>
                    </a>
                </ng-container>
            </div>
            <button type="button" class="fav-more-btn" (click)="toggleShowAll()">
                {{t('More')}}
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </ng-container>

        <!-- FULL MENU (default, or expanded from collapsed) -->
        <ng-container *ngIf="!favMode && (!hasFavorites || showAll)">
            <div class="nav-section" *ngFor="let menu of menus"
                [class.collapsed]="isGroupCollapsed(menu)">
                <button type="button" class="section-title" (click)="toggleGroup(menu, $event)">
                    <span class="section-title-text">{{t(menu.title)}}</span>
                    <svg class="section-chevron" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </button>
                <ng-container *ngIf="!isGroupCollapsed(menu)">
                    <a *ngFor="let item of menu.children"
                        class="nav-item"
                        [routerLink]="routeReplace(item.path, item.route)"
                        routerLinkActive="active">
                        <span class="nav-label">{{t(item.title)}}</span>
                    </a>
                </ng-container>
            </div>
            <button type="button" class="fav-more-btn" *ngIf="hasFavorites" (click)="toggleShowAll()">
                {{t('Less')}}
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                </svg>
            </button>
        </ng-container>
    </nav>

    <!-- Bottom Tools -->
    <div class="sidebar-footer">
        <a [routerLink]="['/document']" target="_blank" class="footer-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"/>
                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1"/>
            </svg>
            Docs
        </a>
        <a [routerLink]="['/lo/reset-password']" class="footer-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
            </svg>
            {{t('Password')}}
        </a>
        <button class="footer-link exit-link" (click)="logout()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
                <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
            {{t('Exit')}}
        </button>
    </div>
</div>
